import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "checkout-turnstile px-8"
};
const _hoisted_2 = {
    key: 0,
    class: "checkout-turnstile__error",
    role: "alert"
};
const _hoisted_3 = { class: "checkout-turnstile__row" };
const _hoisted_4 = ["src"];
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { getTurnstileApi, loadTurnstileScript, reloadTurnstileScript } from '@shared/utils/loadTurnstile';
import { useCheckoutTurnstile } from '@shared/composables/useCheckoutTurnstile';
import { useSiteConfig } from '@shared/composables/useSiteConfig';
import tastioTrustedBadge from '@shared/assets/tastio_trusted.svg';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CheckoutTurnstile',
    setup(__props) {
        const turnstile = useCheckoutTurnstile();
        const { isLoading: siteConfigLoading } = useSiteConfig();
        const isEnabled = computed(() => turnstile.isEnabled.value);
        const loadError = computed(() => turnstile.loadError.value);
        const siteKey = computed(() => turnstile.siteKey.value);
        const containerRef = ref(null);
        let renderSeq = 0;
        const turnstileErrorMessage = (error) => {
            const code = error instanceof Error ? error.message : String(error);
            if (code.includes('turnstile_widget_error:110200') || code.includes('turnstile_widget_error:400')) {
                return 'Die Sicherheitsprüfung ist für diese Domain nicht konfiguriert.';
            }
            if (code.startsWith('turnstile_widget_error:')) {
                return `Die Sicherheitsprüfung ist fehlgeschlagen (${code.replace('turnstile_widget_error:', '')}).`;
            }
            if (code === 'turnstile_script_failed') {
                return 'Die Sicherheitsprüfung konnte nicht geladen werden.';
            }
            return 'Die Sicherheitsprüfung ist vorübergehend nicht verfügbar.';
        };
        const renderWidget = async (options = {}) => {
            if (!isEnabled.value || !siteKey.value || siteConfigLoading.value || !containerRef.value)
                return;
            const seq = ++renderSeq;
            turnstile.clearLoadError();
            try {
                const api = options.forceReload ? await reloadTurnstileScript() : await loadTurnstileScript();
                if (seq !== renderSeq || !containerRef.value)
                    return;
                if (turnstile.widgetId.value) {
                    try {
                        api.remove(turnstile.widgetId.value);
                    }
                    catch {
                        // ignore stale widget
                    }
                    turnstile.widgetId.value = '';
                }
                containerRef.value.innerHTML = '';
                const widgetId = api.render(containerRef.value, {
                    sitekey: siteKey.value,
                    theme: 'light',
                    callback: () => {
                        turnstile.markSolved();
                    },
                    'error-callback': (errorCode) => {
                        turnstile.setLoadError(turnstileErrorMessage(new Error(`turnstile_widget_error:${errorCode || 'unknown'}`)));
                        turnstile.reset();
                    },
                    'expired-callback': () => {
                        turnstile.reset();
                    }
                });
                if (!widgetId) {
                    turnstile.setLoadError(turnstileErrorMessage(new Error('turnstile_render_failed')));
                    return;
                }
                turnstile.widgetId.value = widgetId;
            }
            catch (error) {
                turnstile.setLoadError(turnstileErrorMessage(error));
            }
        };
        const scheduleRender = async () => {
            await nextTick();
            void renderWidget();
        };
        const retry = () => {
            turnstile.clearLoadError();
            void renderWidget({ forceReload: true });
        };
        onMounted(() => {
            void scheduleRender();
        });
        watch(siteKey, (next, prev) => {
            if (next && next !== prev) {
                void scheduleRender();
            }
        });
        watch(isEnabled, (enabled) => {
            if (enabled) {
                void scheduleRender();
            }
        });
        watch(siteConfigLoading, (loading, wasLoading) => {
            if (wasLoading && !loading && isEnabled.value) {
                void scheduleRender();
            }
        });
        onUnmounted(() => {
            renderSeq += 1;
            const api = getTurnstileApi();
            if (turnstile.widgetId.value && api) {
                try {
                    api.remove(turnstile.widgetId.value);
                }
                catch {
                    // ignore
                }
            }
            turnstile.widgetId.value = '';
        });
        return (_ctx, _cache) => {
            return (isEnabled.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (loadError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                            _createTextVNode(_toDisplayString(loadError.value) + " ", 1 /* TEXT */),
                            _createElementVNode("button", {
                                type: "button",
                                class: "checkout-turnstile__retry",
                                onClick: retry
                            }, "Erneut laden")
                        ]))
                        : _createCommentVNode("v-if", true),
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            src: _unref(tastioTrustedBadge),
                            alt: "Tasti-o Trusted Shop",
                            class: "checkout-turnstile__trusted",
                            width: "256",
                            height: "102",
                            decoding: "async"
                        }, null, 8 /* PROPS */, _hoisted_4),
                        _createElementVNode("div", {
                            ref_key: "containerRef",
                            ref: containerRef,
                            class: "checkout-turnstile__slot",
                            "aria-live": "polite"
                        }, null, 512 /* NEED_PATCH */)
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, !loadError.value]
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
